import React, { lazy } from "react";

const Blogs = lazy(() => import("../../modules/blogs/container"));
const BlogDetails = lazy(() => import("../../modules/blogs/container/blog-details"));
export const blogRoutes = [
	{
		path: "/blogs",
		element: <Blogs />
	},
	{
		path: "/blogs/:id",
		element: <BlogDetails />
	}
];

